export const ajaxContent = {
	loadAjaxContent: ( container ) => {
		if ( ! container.dataset.hasOwnProperty( 'action' ) || ! container.dataset.hasOwnProperty( 'ajaxUrl' ) ) {
			return;
		}
		const action = container.dataset.action;
		const ajaxUrl = container.dataset.ajaxUrl;
		const params = container.dataset.params ?? [];
		const data = new FormData();
		data.append( 'action', action );
		data.append( 'params', params );
		fetch( ajaxUrl, {
			method: 'POST',
			credentials: 'same-origin',
			body: data,
		} ).then( ( res ) => res.json() )
			.then( ( response ) => {
				if ( response.success === true ) {
					const responseContent = response.data.content ?? '';
					if ( responseContent !== '' ) {
						const content = document.createElement( 'div' );
						content.innerHTML = responseContent.trim();
						container.parentNode.replaceChild( content.firstChild, container );
					}
				} else if ( response.data[ 0 ].message !== '' ) {
					console.error( response.data[ 0 ].message );
				}
			} )
			.catch( ( error ) => {
				console.error( error );
			} );
	},
};
